import { styledComponent, Divider } from '@hermes/web-components'

export const SearchCardsDivider = styledComponent(Divider)(({ theme }) => ({
  width: '100%',
  height: '4px',
  border: 'none',
  backgroundColor: theme.palette.grey[100],
  [theme.breakpoints.up('lg')]: {
    display: 'none'
  }
}))
